/** How long the Re-Exposures note stays dismissed. */
const DISMISSED_FOR_MS = 14 * 24 * 60 * 60 * 1000;

/**
 * The Re-Exposures note in a broker's exposure sidebar, which a member dismisses for two weeks at a
 * time, kept across reloads for that member alone.
 */
export const useReExposuresNoteStore = defineStore(
    're-exposures-note',
    () => {
        // When the member last dismissed the note, in milliseconds since the epoch.
        const dismissedAt = ref<number | null>(null);

        // Two weeks from the dismissal, measured as the page first shows the note: a page left open
        // past that shows it again once it reloads.
        const dismissed = computed(() => dismissedAt.value !== null && Date.now() - dismissedAt.value < DISMISSED_FOR_MS);

        function dismiss() {
            dismissedAt.value = Date.now();
        }

        return { dismissedAt, dismissed, dismiss };
    },
    { persist: true }
);

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useReExposuresNoteStore, import.meta.hot));
}
